import React, {useEffect} from "react";
import {useDispatch} from "react-redux";

import {apiSetAlert} from "../../api/appApi";

import Warning from "../../assets/svg/Attention.svg";
import Error from "../../assets/svg/error.svg";
import Success from "../../assets/svg/success.svg";
import Info from "../../assets/svg/warning-blue-alert-.svg";

import "../../assets/styles/components/alert.scss";

export default function Alert({show, type, message}) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (show) {
            setTimeout(() => {
                dispatch(apiSetAlert(null, null, false));
            }, 4500);
        }
    }, [show]);

    return show ? (
        <div
            className={
                type === "info"
                    ? "warp-alert-info"
                    : type === "error"
                        ? "warp-alert-error"
                        : type === "success"
                            ? "warp-alert-success"
                            : type === "warning"
                                ? "warp-alert-warning"
                                : ""
            }
        >
            <div className="img-exit">
                {type === "info" ? (
                    <img src={Info} alt="exitImg"/>
                ) : type === "error" ? (
                    <img src={Error} alt="exitImgError"/>
                ) : type === "warning" ? (
                    <img src={Warning} alt="exitImgSuccess"/>
                ) : type === "success" ? (
                    <img src={Success} alt="exitImgSuccess"/>
                ) : (
                    ""
                )}
            </div>
            <div>
                {typeof message === "object"
                    ? message.map((m , index) => {
                        return <div key={index}> - {m}</div>;
                    })
                    : message}
            </div>
        </div>
    ) : null;
}
